module.exports = __webpack_public_path__ + "img/mobile-money.33726da3.svg";